export default __webpack_public_path__ + "static/media/blurb_cloud_right.e7db2d9e.svg";